<template>
  <div :class="$style.reports">
    <reports-title
      ref="reportsTitle"
      :title="pageTitle"
    />
    <reports-toolbar
      ref="reportsToolbar"
      :report-title="pageTitle"
      :toolbar-disabled="!filteredTableData.length"
      @onClickExport="onExport"
    />
    <!-- <tanstack-table
      id="report_export_id"
      ref="tableRef"
      :is-full-height="true"
      :config="tableConfig"
      @contextMenu="contextMenu"
      @sortingChanged="sortingChanged"
    />
    <div
      v-if="isShowStub"
      :class="$style.stub_with_image"
    >
      <div :class="$style.wrapper">
        <vgp-svg-image
          name="comment-hub-no-search"
        />
        <div :class="$style.desc">
          {{ locale('report_page_no_filtered_data') }}
        </div>
      </div>
    </div> -->

    <report-table
      ref="table"
      :config="tableConfig"
      :rows-data="filteredTableData"
      :grouping="[]"
      :local-storage-table-id="currentFilter.type"
      :style="{ height: contentHeight }"
    />
  </div>
</template>

<script>
import reportsTitle from '../include/title.vue';
import reportsToolbar from '../include/toolbar.vue';
import multiViewsProjects from '../../../models/multiViewsProjects';
import Export from '../include/export/export';
import reportsConstants from '../include/constants';
import projectsModel from '../../../models/projects';
import reportTable from '../include/table/table.vue';
import tableConfigs from '../progress/configTable';
import Filter from '../../filter/filter';
import controllerPortfolio from '../progress/controllerReportPortfolioList';

export default {
  name: 'ProjectListReport',
  components: {
    reportsTitle, reportsToolbar, reportTable,
  },
  props: {

  },
  data() {
    return {
      type: null,
      locale: __,
      tableData: [],
      filterProjectIds: [],
      filterPortfolioIds: [],
      contentHeight: '0px',
    };
  },
  computed: {
    pageTitle() {
      return reportsConstants.TITLE.progress.projectsList;
    },
    currentFilter() {
      return this.$store.getters['filter/currentFilter'];
    },
    tableConfig() {
      return tableConfigs.portfolio;
    },
    filteredTableData() {
      const { owner_id, project_status } = this.currentFilter.properties;

      let filtered = this.tableData.filter(item => {
        if (owner_id?.length) {
          return owner_id.includes(item.creator.id);
        }

        return item;
      });

      filtered = filtered.filter(item => {
        if (project_status?.length) {
          return project_status.includes(item.status.id);
        }

        return item;
      });

      return filtered;
    },
    sourceType() {
      if (this.filterPortfolioIds.length) {
        return 'multiview';
      }

      return 'projects';
    },
  },
  watch: {
    'currentFilter.properties': {
      handler(newProps, oldProps) {
        if (newProps === undefined || oldProps === undefined) return;

        this.initByFilter(newProps, oldProps)
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.init();

        const reportNameAnalytics = this.pageTitle.replace(/^exmp_chart_/, '').replace(/_title$/, '');
        const projectIds = [this.filterProjectIds, this.filterPortfolioIds].find(arr => arr.length) || [];

        userExtAnalytics.log('report_open', {
          report_type: reportNameAnalytics,
          source_type: this.sourceType,
          projects_selected_count: projectIds.length,
        });
      });
    });    
    
    this.calcContentHeight();
    window.addEventListener('resize', this.calcContentHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calcContentHeight);
  },
  methods: {
    calcContentHeight() {
      const viewportHeight = document.documentElement.clientHeight || window.innerHeight || 0;

      const titleRef = this.$refs.reportsTitle;
      const toolbarRef = this.$refs.reportsToolbar;

      const titleEl = titleRef && (titleRef.$el || titleRef);
      const toolbarEl = toolbarRef && (toolbarRef.$el || toolbarRef);

      const titleHeight = titleEl?.getBoundingClientRect().height || 0;
      const toolbarHeight = toolbarEl?.getBoundingClientRect().height || 0;

      const height = Math.max(viewportHeight - titleHeight - toolbarHeight, 0);

      this.contentHeight = `${height}px`;
    },
    init() {
      this.setGanttIds(this.currentFilter?.properties?.gantt_id);
      this.setPortfolioProjectIds(this.currentFilter?.properties?.portfolio_id);
      this.createReport();
    },
    initByFilter(newProps, oldProps = null) {
      let needRecalculate = false;

      Filter.watchChangedFilterProps(newProps, oldProps, {
        gantt_id: newFilterGanttIds => {
          needRecalculate = true;
          this.setGanttIds(newFilterGanttIds)
        },
        portfolio_id: newFilterProtfolioIds => {
          needRecalculate = true;
          this.setPortfolioProjectIds(newFilterProtfolioIds);
        },
      });

      if (needRecalculate) {
        this.createReport();
      }
    },

    createReport() {
      let ids = [this.filterProjectIds, this.filterPortfolioIds].find(arr => arr.length) || [];

      if (!ids.length) {
        ids = projectsModel.getAllProjects().map(project => project.gantt_id);
        this.filterProjectIds = ids;
      }

      this.tableData = controllerPortfolio.createReport(ids);
    },

    setGanttIds(newVal) {
      if (newVal?.length) {
        this.filterPortfolioIds = [];
        this.filterProjectIds = [...newVal];
      } else {
        this.filterProjectIds = [...newVal];
      }
    },

    setPortfolioProjectIds(newVal) {
      if (newVal?.length) {
        const multiviewData = multiViewsProjects.getProjectDataById(newVal[0]);

        this.filterProjectIds = [];
        this.filterPortfolioIds = [...multiviewData.ganttIDs];
      } else {
        this.filterPortfolioIds = [];
      }
    },

    sortingChanged(payload) {
      this.sortingState = payload;
    },

    onExport() {
      Export.exportTanstackTableDataToExcel({
        title: __(`${this.pageTitle}`),
        tableInstance: this.$refs.table?.tableController?.tableInstance,
      });

      userExtAnalytics.log('report_export_done', {
        export_format: 'XLSX',
        report_type: 'project_list',
      });
    },
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
